__turbopack_context__.v({
  "chevron": "Accordion-module__AIInSq__chevron",
  "panel": "Accordion-module__AIInSq__panel",
  "panelInner": "Accordion-module__AIInSq__panelInner",
  "root": "Accordion-module__AIInSq__root",
  "summary": "Accordion-module__AIInSq__summary",
  "trigger": "Accordion-module__AIInSq__trigger",
});
